<template>
    <v-container fluid>
        <v-row class="pl-4 pr-4">
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-adresse'"
                        >{{ $t('lang_GENERIC_AZ_CAPTION_ADDRESS') }}:
                            <BaseIcon   
                                :alvqa="alvqa + '-icon-address-copy-to-clipboard'"
                                :small="true"
                                icon="content_copy" 
                                color="buttonStandard"
                                @click.stop="copyToClipboard($alvPlugin.getAddressInternational(item))"
                            />
                        </div>
                        <span :alvqa="alvqa + '-address'" 
                            v-html="$alvPlugin.getAddressInternational(item)">
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col v-if="item.fullShippingAddress != '' && item.fullShippingAddress != null">
                <v-card elevation="0">
                    <v-card-text>
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-full-shipping-address'"
                            >{{ $t('lang_AZ_GROUPS_CAPTION_SHIPPING_ADDRESS') }}:</div>
                            <div v-html="item.fullShippingAddress" :alvqa="alvqa + '-full-shipping-address'"></div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <!-- ALVID -->
                        <span v-if="item.alvId != '' && item.alvId != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alvid'"
                            >{{ $t('lang_GENERIC_CAPTION_ALVID') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-alvid'"
                            >{{ item.alvId }}</div>
                        </span>

                        <!-- EMAIL -->
                        <span v-if="item.email != '' && item.email != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-email'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_EMAIL') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-email'"
                            >{{ item.email }}</div>
                        </span>

                        <!-- PHONE -->
                        <span v-if="item.phone != '' &&item.phone != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-phone'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_PHONE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-phone'"
                            >{{ item.phone }}</div>
                        </span>

                        <!-- MOBILE -->
                        <span v-if="item.cellphone != '' && item.cellphone != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-cellphone'"
                            >{{ $t('lang_AZ_PERSONS_CAPTION_CELLPHONE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-cellphone'"
                            >{{ item.cellphone }}</div>
                        </span>

                        <!-- FAX -->
                        <span v-if="item.fax != '' && item.fax != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-fax'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_FAX') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-fax'"
                            >{{ item.fax }}</div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        
                        <!-- KEY NAME -->
                        <span v-if="item.keyName != '' && item.keyName != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-gema-name'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_GEMA_NAME') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-gema-name'"
                            >{{ item.keyName }}</div>
                        </span>

                        <!-- WEB -->
                        <span v-if="item.web != '' && item.web != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-web'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_WEB') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-web'"
                            >
                                <a :href="getLinkWithHttp(item.web)" target="_blank">{{ item.web }}</a>
                            </div>
                        </span>

                        <!-- FACEBOOK -->
                        <span v-if="item.facebook != '' && item.facebook != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-facebook'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_FACEBOOK') }}:</div>
                            <div :alvqa="alvqa + '-facebook'"
                            >
                            <a :href="getLinkWithHttp(item.facebook)" target="_blank">{{ item.facebook }}</a>
                            </div>
                        </span>

                        <!-- YOUTUBE -->
                        <span v-if="item.youtube != '' && item.youtube != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-youtube'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_YOUTUBE') }}:</div>
                            <div :alvqa="alvqa + '-youtube'"
                            >{{ item.youtube }}</div>
                        </span>

                        <!-- TWITTER -->
                        <span v-if="item.twitter != '' && item.twitter != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-twitter'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_TWITTER') }}:</div>
                            <div :alvqa="alvqa + '-twitter'"
                            >{{ item.twitter }}</div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="pl-4 pr-4">
            <v-col v-if="item.notes != '' && item.notes != null">
                <!-- NOTES -->
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="item.notes != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notes'"
                            >{{ $t('lang_GENERIC_CAPTION_NOTES') }}:</div>
                            <div
                                :alvqa="alvqa + '-notes'"
                                v-html="item.notes"
                            ></div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col v-if="item.shippingNote != '' && item.shippingNote != null">
                <!-- SHIPPING NOTES -->
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="item.shippingNote != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-shipping-notes'"
                            >{{ $t('lang_AZ_GROUPS_CAPTION_SHIPPING_NOTE') }}:</div>
                            <div :alvqa="alvqa + '-shipping-notes'" v-html="item.shippingNote"></div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col v-if="item.tags != '' && item.tags != null">
                <!-- TAGs -->
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="item.tags != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-tags'"
                            >{{ $t('lang_GENERIC_CAPTION_TAGS') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-tags'"
                            >{{ item.tags }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <AzLiveVenueRoomsReadOnlyPanel :id="item.id"/>
                </v-expansion-panels>
            </v-col>
        </v-row> -->
    </v-container>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'
import AzLiveVenueRoomsReadOnlyPanel from './_panels/AzLiveVenueRoomsReadOnlyPanel'

export default {
    name: "AzLiveReadOnly",
    components: {
        BaseIcon,
        AzLiveVenueRoomsReadOnlyPanel
    },
    data() {
        return {
            alvqa: 'az-live-list-read-only'
        }
    },
    computed: {
        item() { return this.$store.getters.getExpandedAzLive[0] }
    },
    methods: {
        copyToClipboard(item) {
            let address = item.replace(/<br\s*[\/]?>/gi, "\n")
            navigator.clipboard.writeText(address);
        },
        getType(selectedType) {
            let types = [{'text': 'type 1', 'value': '0'}, {'text': 'type 2', 'value': '1'}]

            let match = types.find(type => {
                return type.value === selectedType
            })

            if(match === undefined) return ''
            // else return this.$t(match.text)
            else return match.text
        },
        getLinkWithHttp(weblink) {
            if(!weblink.startsWith('http')) return 'http://' + weblink
            else return weblink
        }
    },
    created() {
        this.$store.commit('setCountries')
    }
}
</script>